import { useFormik } from 'formik';
import { MutableRefObject, useEffect, useRef, useState } from 'react';
import { Col, Nav, Row, Tab } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { StylesConfig } from "react-select";
import { toast } from 'react-toastify';
import Ribbon from '../../../core/common/ribbon/ribbon';
import { useGetAllActiveUsersQuery, useGetLeadInquiryDataByIdQuery, useGetLeadInquirylookupsQuery, useUpdateLeadInquiryMutation } from '../../../services/EndPointsApis';
import { svgIcons } from '../../../style/fonts/SvgIcons';
import LeadsUserDetail from '../LeadsTabs/LeadsUserDetail';
import AppointmentTab from './LeadInquiryTabs/AppointmentTab/AppointmentTab';
import GeneralTabCol1 from './LeadInquiryTabs/AppointmentTab/GeneralTab/GeneralTabsCol1';
import GeneralTabCol2 from './LeadInquiryTabs/AppointmentTab/GeneralTab/GeneralTabsCol2';
import GeneralTabCol3 from './LeadInquiryTabs/AppointmentTab/GeneralTab/GeneralTabsCol3';
import Debriefing from './LeadInquiryTabs/DebriefingTab';
import MarketingTab from './LeadInquiryTabs/MarketingTab';
import ProductServicesTab from './LeadInquiryTabs/ProductServicesTab';
import ProgressStepperLeadInquiry from './ProgressStepperLeadInquiry/ProgressStepperLI';
import * as Yup from "yup";
import React from 'react';


const UpdateLeadInquiry = () => {

  const location = useLocation();
  const isReadOnly = location.pathname.includes('viewLeadInquiry');
  const isEditing = location.pathname.includes('editLeadInquiry');
  const [updateId, setUpdateId] = useState(0);

  const navigate = useNavigate()
  const params = useParams();

  const LeadInquiryId = params.id;


  const handleBack = () => {
    navigate('/leadsInquiry')
  }

  const customStyles: StylesConfig = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "rgba(177, 31, 40, 1)",
      },
    }),
  };
  const items = [
    {
      icon: svgIcons.BackIcon, onClick: handleBack,
    },
    // { tooltipLabel: "Results", icon: svgIcons.SaveIcon },

  ]

  //Get Lead Inquiry Data By Id 
  const { data: leadsInquirybyId, refetch, isLoading } = useGetLeadInquiryDataByIdQuery({ Id: LeadInquiryId });
  // update Lead Inquiry 

  const [UpdateLeadInquiry, { data, isError, error, isSuccess, isLoading: UpdateLoading }] = useUpdateLeadInquiryMutation();

  //Get Lead Inquiry lookup
  const { data: leadsInquiryLookups, refetch: LeadInquiryLookups, isLoading: LeadInquiryLoading } = useGetLeadInquirylookupsQuery('');

  //Get Default lookups
  // const { data: getdefaultLookups, refetch: defualtRefetch } = useGetDefaultlookupsQuery('');

  const getdefaultLookups = useSelector((state: any) => state.auth.apiData);
  //All active Users 
  const { data: getallActiveUsers, refetch: activeUsersRefetch } = useGetAllActiveUsersQuery('');




  //Formik 

  const initialValues = {
    id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    currentStep: 0,
    name: "",
    leadProspectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    recordNumber: "",
    firstName: "",
    lastName: "",
    lst_Prefix: {
      id: 0,
      value: "",
    },
    title: "",
    emailAddress: "",
    mainPhone: "",
    mobilePhone: "",
    lst_MainPhoneType: {
      id: 0,
      value: "",
    },
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    addressCity: "",
    addressStateOrProvince: "",
    addressPostalCode: "",
    addressComposite: "",
    lst_MethodOfInquiry: {
      id: 0,
      value: "",
    },
    prospectDate: "2024-09-19T12:45:29.300Z",
    consultationDate: "2024-09-19T12:45:29.300Z",
    projectDetails: "",
    leadIntakeNotes: "",
    leadQualificationNotes: "",
    lst_ProjectFinancing: {
      id: 0,
      value: "",
    },
    lst_ProjectType: {
      id: 0,
      value: "",
    },
    projectBudget: 0,
    projectBudgetNotes: "",
    lst_VerifiedProspect: {
      id: 0,
      value: "",
    },
    lst_VerifiedContact: {
      id: 0,
      value: "",
    },
    lst_ExistingLead: {
      id: 0,
      value: "",
    },
    lst_LeadQualityCode: {
      id: 0,
      value: "",
    },
    lst_LeadProspectStatusCode: {
      id: 0,
      value: "",
    },
    createdOn: "2024-09-19T12:45:29.300Z",
    modifiedOn: "2024-09-19T12:45:29.300Z",
    overriddenCreatedOn: "2024-09-19T12:45:29.300Z",
    createdBy: 0,
    modifiedBy: 0,
    createdOnBehalfBy: 0,
    modifiedOnBehalfBy: 0,
    lst_EnteredBy: {
      id: 0,
      value: "",
    },
    leadSource: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    lst_LeadSourceType: {
      id: 0,
      value: "",
    },
    lst_LeadSourceCode: {
      id: 0,
      value: "",
    },
    leadSourceNotes: "",
    lst_LeadTaker: {
      id: 0,
      value: "",
    },
    leadInquiry: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    webFormEntry: 0,
    lst_Account: {
      id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      value: "",
    },
    lst_Contact: {
      id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      value: "",
    },
    lst_Leads: {
      id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      value: "",
    },
    description: "",
    lst_FeedStreamType: {
      id: 0,
      value: "",
    },
    lst_FeedStreamObjectType: {
      id: 0,
      value: "",
    },
    feedStreamObjectName: "",
    feedStreamObjectId: "",
    feedStreamReferrer: "",
    feedStreamSearchPhrase: "",
    feedStreamContextId: "",
    feedStreamContext: "",
    lst_FeedStreamInputDeviceType: {
      id: 0,
      value: "",
    },
    feedStreamData: "",
    feedStreamSource: "",
    utmSource: "",
    lst_PrintedCirculation: {
      id: 0,
      value: "",
    },
    trafficSource: "",
    lst_DigitalBlast: {
      id: 0,
      value: "",
    },
    lst_Dasuppport: {
      id: 2,
      value: "No",
    },
    contactPreferences: "",
    lst_FeedStreamOperatingSys: {
      id: 0,
      value: "",
    },
    roofing: "",
    siding: "",
    stuccoOrEIFS: "",
    michaelBennetHomes: "",
    lambFinancial: "",
    exteriormakover: "",
    elevations: "",
    addition: "",
    remodel: "",
    revive: "",
    appliances: "",
    lst_Radio: {
      id: 0,
      value: "",
    },
    lst_TV: {
      id: 0,
      value: "",
    },
    lst_Signage: {
      id: 0,
      value: "",
    },
    lst_Broadcast: {
      id: 0,
      value: "",
    },
    lst_Influencer: [
      {
        id: 0,
        value: "",
      },
    ],
    lst_EventsExhibits: {
      id: 0,
      value: "",
    },
    targetPopulation: "",
    hhIncome250K: true,
    hhValue400K: true,
    ageGroup3474: "",
    zillowEstimate: "",
    lst_SalesConsultant: {
      id: 0,
      value: "",
    },
    lst_WebSearchEngine: {
      id: 0,
      value: "",
    },
    lst_SearchEnginePaid: {
      id: 0,
      value: "",
    },
    lst_WebSearchEngineOrganic: {
      id: 0,
      value: "",
    },
    lst_WebSocialMediaRoot: {
      id: 0,
      value: "",
    },
    lst_WebSocialMediaNetwork: {
      id: 0,
      value: "",
    },
    lst_ReferralProgram: {
      id: 0,
      value: "",
    },
    lst_WebsiteDirect: {
      id: 0,
      value: "",
    },
    lst_WebsiteThirdParty: {
      id: 0,
      value: "",
    },
    lst_Subject: {
      id: 0,
      value: "",
    },
    airoom: 0,
    masonry: "",
    bathroomRemodel: 0,
    feedStreamRecordIdentifier: "",
    feedStreamPostId: "",
    feedRawReferrer: "",
    lst_Owner: {
      id: 0,
      value: "",
    },
    ctmCallerID: "",
    lst_ProjectStatus: {
      id: 0,
      value: "",
    },
    lst_SubStatus: {
      id: 0,
      value: "",
    },
    lst_EvaluateFit: {
      id: 0,
      value: "",
    },
    lst_ConfirmInterest: {
      id: 0,
      value: "",
    },
    lst_Rating: {
      id: 0,
      value: "",
    },
    lst_CanPromote: {
      id: 0,
      value: "",
    },
    lst_StatusReason: {
      id: 0,
      value: "",
    },
    lst_Status: {
      id: 0,
      value: "",
    },
    lst_FreshAptDuration: {
      id: 0,
      value: "",
    },
    lst_PropertyType: {
      id: 0,
      value: "",
    },
    lst_AiroomCompanies: {
      id: 0,
      value: "",
    },
    lst_HideAndShow: {
      id: 1,
      value: "Yes",
    },
    lst_PurchaseTimeFrame: {
      id: 0,
      value: "",
    },
    lst_FreshAptStatus: {
      id: 0,
      value: "",
    },
    freshAptTime: '',
    freshAptDate: '',
    daNotes: "",
    priorityCode: 0,
    rating: 0,
    evaluateFit: true,
    confirmInterest: true,
    inquiryDate: "",
    qualifyDate: "",
    budgetRangeMin: 0,
    budgetRangeMax: 0,
    rangeIndicatedMin: 0,
    rangeIndicatedMax: 0,
    rangeAssessedMin: 0,
    rangeAssessedMax: 0,
    costBookAmount: 0,
    pdmJobEstimated: 0,
    estimatedCloseDate: "",
    homePurchasePrice: 0,
    mortgageTerm: 0,
    cashToInvest: 0,
    retainerAskedAmount: 0,
    retainerAmountCollected: 0,
    currentMortgageBalance: 0,
    saleAmount: 0,
    downPaymentAmount: 0,
    financedAmount: 0,
    contractAmount: 0,
    question1
      :
      "",
    question2
      :
      "",
    question3
      :
      "",
    question4
      :
      "",
    lst_QualificationTimeFrame: {
      id: 0,
      value: "",
    },
    financeLoanType: "",
    lst_Relationships: [
      {
        id: 0,
        value: "",
      },
    ],
    estimatedCloseTime: "",
    contractTime: "",
    downPaymentTime: "",
    saleTime: "",
    lst_AiroomProductAndServices: {
      id: 0,
      value: ""
    },
    lst_APSSec1: [
      {
        id: 0,
        value: ""
      }
    ],
    lst_APSSec2: [
      {
        id: 0,
        value: ""
      }
    ],
    lst_APSSec3: [
      {
        id: 0,
        value: ""
      }
    ],
  };

  interface FormFieldRefs {
    inquiryDate: MutableRefObject<HTMLInputElement | null>;
    qualifyDate: MutableRefObject<HTMLInputElement | null>;
    lst_Account: MutableRefObject<HTMLInputElement | null>;
    lst_MethodOfInquiry: MutableRefObject<HTMLInputElement | null>;
    lst_EnteredBy: MutableRefObject<HTMLInputElement | null>;
    lst_Subject: MutableRefObject<HTMLInputElement | null>,
    lst_PurchaseTimeFrame: MutableRefObject<HTMLInputElement | null>,
    pdmJobEstimated: MutableRefObject<HTMLInputElement | null>,
    cashToInvest: MutableRefObject<HTMLInputElement | null>,
    financedAmount: MutableRefObject<HTMLInputElement | null>,
    saleAmount: MutableRefObject<HTMLInputElement | null>,
    downPaymentAmount: MutableRefObject<HTMLInputElement | null>,
    contractAmount: MutableRefObject<HTMLInputElement | null>,
  }

  //for refer to formik errors
  const formFieldRefs = {
    inquiryDate: React.useRef<HTMLInputElement | null>(null),
    qualifyDate: useRef(null),
    lst_Account: useRef(null),
    lst_MethodOfInquiry: useRef(null),
    lst_Subject: useRef(null),
    lst_PurchaseTimeFrame: useRef(null),
    pdmJobEstimated: useRef(null),
    cashToInvest: useRef(null),
    financedAmount: useRef(null),
    saleAmount: useRef(null),
    downPaymentAmount: useRef(null),
    contractAmount: useRef(null),
    lst_EnteredBy: useRef(null),
  };
  const scrollToField = (fieldKey: keyof FormFieldRefs) => {
    const ref = formFieldRefs[fieldKey].current;
    if (ref) {
      ref.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      console.error(`Ref for ${fieldKey} is null or not a valid element.`);
    }
  };

  const LeadInquirySchema = Yup.object().shape({
    inquiryDate: Yup.string()
      .required("Inquiry Date is required"),
    qualifyDate: Yup.string()
      .required("Qualify Date is required"),
    lst_Account: Yup.object().shape({
      id: Yup.string().required('Account is required'),
      value: Yup.string().required('Account title is required'),
    }),
    lst_MethodOfInquiry: Yup.object().shape({
      id: Yup.number().required('Method of Inquiry is required'),
      value: Yup.string().required('Method of Inquiry title is required'),
    }),
    lst_Subject: Yup.object().shape({
      id: Yup.number().required('Subject is required'),
      value: Yup.string().required('Subject is required'),
    }),
    // lst_Leads: Yup.object().shape({
    //     id: Yup.string().required('Lead Prospect is required'),
    //     value: Yup.string().required('Lead Prospect is required'),
    // }).when('lst_ExistingLead.id', ([id], schema) => {
    //     return parseInt(id) === 1
    //         ? schema.shape({
    //             id: Yup.string().required('Lead Prospect is required'),
    //             value: Yup.string().required('Lead Prospect is required'),
    //         })
    //         : schema.shape({
    //             id: Yup.string(),
    //             value: Yup.string(),
    //         });
    // }),
    lst_PurchaseTimeFrame: Yup.object().shape({
      id: Yup.number().required('Purchase Time Frame is required'),
      value: Yup.string().required('Purchase Time Frame is required'),
    }),
    pdmJobEstimated: Yup.number()
      .required("Pdm Job Estimated is required"),
    lst_ProjectFinancing: Yup.object().shape({
      id: Yup.number().required('Project Financing is required'),
      value: Yup.string().required('Project Financing is required'),
    }),
    cashToInvest: Yup.number()
      .required("Cash To Invest is required"),
    financedAmount: Yup.number()
      .required("Financed Amount is required"),
    saleAmount: Yup.number()
      .required("Sale Amount is required"),
    downPaymentAmount: Yup.number()
      .required("Down Payment Amount is required"),
    contractAmount: Yup.number()
      .required("Contract Amount is required"),
    // lst_EnteredBy: Yup.object().shape({
    //   id: Yup.number().required('EnteredBy is required'),
    //   value: Yup.string().required('EnteredBy is required'),
    // }),
    // lst_EnteredBy: Yup.object().shape({
    //   id: Yup.number().required('EnteredBy is required'),
    //   value: Yup.string().required('EnteredBy is required'),
    // }),
  })

  const formik = useFormik({
    validationSchema: LeadInquirySchema,
    initialValues,
    onSubmit: (values) => {
      UpdateLeadInquiry({ ...values })
    }
  });

  const { resetForm } = formik;
  const [activeState, InactiveState] = useState(false)
  const [submitted, IsSubmitted] = useState(false)
  const [shouldNavigate, setShouldNavigate] = useState(false);


  useEffect(() => {
    if (isSuccess && activeState === false) {
      toast.success(data?.message);
      // resetForm()
      refetch()
      // allLeadsTrigger('')
      // navigate('/leadsInquiry')
      // navigate(route.manageusers);
    }
    if (formik.values.currentStep === 2 || activeState === true) {
      refetch()
    }
  }, [isSuccess, data, formik.values.currentStep, activeState]);

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = 'Something went wrong';

      if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
        errorMessage = (error.data as { message: string }).message;
      }
      toast.error(errorMessage);
    }

  },
    [isError, error]);

  const handleSave = () => {
    formik.handleSubmit()
    IsSubmitted(true)
    InactiveState(false)
  }

  useEffect(() => {
    if (leadsInquirybyId?.result && Object.keys(leadsInquirybyId?.result).length > 0) {
      setUpdateId(leadsInquirybyId?.result?.leadInquiryId);
      formik.setValues({ ...leadsInquirybyId?.result });
    } else {
      setUpdateId(0);
    }
  }, [leadsInquirybyId]);

  useEffect(() => {
    refetch()
  }, [])

  const handleUpdateClose = () => {
    formik.handleSubmit()
    IsSubmitted(true)
    setShouldNavigate(true)
  }

  useEffect(() => {
    if (isSuccess && shouldNavigate) {
      navigate('/leadsInquiry');
    }
  }, [isSuccess, shouldNavigate]);
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className='row'>
            <div className='col-md-12'>
              <div className=''>
                {Object.keys(formik.errors).length > 0 && submitted && (
                  <div className="accordion accordion-flush" id="accordionFlushExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="flush-headingOne">
                        <button
                          className="accordion-button collapsed bg-redd"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#flush-collapseOne"
                          aria-expanded="false"
                          aria-controls="flush-collapseOne"
                        >
                          Show All Errors
                        </button>
                      </h2>
                      <div
                        id="flush-collapseOne"
                        className="accordion-collapse collapse"
                        aria-labelledby="flush-headingOne"
                        data-bs-parent="#accordionFlushExample"
                      >
                        {/* Map through formik.errors to display each error in its own alert */}
                        {Object.keys(formik.errors).map((key) => {
                          const error = formik.errors[key as keyof typeof formik.errors];

                          return (
                            <div
                              className="alert p-0 m-0 alert-primary d-flex align-items-center"
                              role="alert"
                              key={key}
                              onClick={() => scrollToField(key as keyof FormFieldRefs)}
                            >
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                              >
                                <i className='fa fa-close'></i>
                              </button>
                              {/* <strong>{key}:</strong> */}
                              {typeof error === 'string' ? (
                                <span> {error}</span>
                              ) : Array.isArray(error) ? (
                                error.map((err: any, index) => (
                                  <div key={index}>
                                    <span>{err}</span>
                                  </div>
                                ))
                              ) : typeof error === 'object' && error !== null ? (
                                Object.keys(error).map((subKey, subIndex) => (
                                  <div key={subIndex}>
                                    <span>{`${subKey}: ${JSON.stringify(error[subKey as keyof typeof error])}`}</span>
                                  </div>
                                ))
                              ) : null}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <Ribbon
                items={items}
                buttonText={
                  (UpdateLoading ? 'Please wait...' : 'Update')
                }
                disabled={UpdateLoading}
                buttonText2='Update & Close'
                onClickbtn2={handleUpdateClose}
                buttonClass="add-popup ribbon-btn "
                onClickbtn={handleSave}
              />
            </div>
          </div>
          <Tab.Container id="left-tabs-example" defaultActiveKey="productServices">
            <Row >
              <Col sm={12}>
                <div className='card card-css'>
                  <div className='card-bodycard-css p-2'>
                    <div className='d-flex justify-content-between mb-3'>
                      <div className=''>
                        <h4 className='color-red'>{leadsInquirybyId?.result?.leadInquiryRecNumber}<span className='fs-12 text-muted'> - Saved</span></h4>
                        <p>{isEditing ? 'Editing Lead Inquiry' : 'Viewing Lead Inquiry'}</p>
                      </div>
                      <div className='d-flex gap-2'>
                        {/* <div>
                          <p className='mb-0 fs-13 fw-600'>
                            LI-012345
                          </p>
                          <p className='fs-11'>
                            Lead Inquiry ID
                          </p>
                        </div>
                        <div style={{ borderRight: '1px solid gray' }}></div> */}
                        <div>
                          <p className='mb-0 fs-13 fw-600'>
                            {formik?.values?.lst_Contact?.value}
                          </p>
                          <p className='fs-11'>
                            Contact
                          </p>
                        </div>
                        <div style={{ borderRight: '1px solid gray' }}></div>
                        <div>
                          <p className='mb-0 fs-13 fw-600'>
                            {formik?.values?.lst_SalesConsultant?.value || '....'}
                          </p>
                          <p className='fs-11'>
                            Sales Consultant
                          </p>
                        </div>
                        <div style={{ borderRight: '1px solid gray' }}></div>
                        <div>
                          <p className='mb-0 fs-13 fw-600'>
                            {formik?.values?.lst_Owner?.value || '.....'}
                          </p>
                          <p className='fs-11'>
                            Owner
                          </p>
                        </div>
                        <div style={{ borderRight: '1px solid gray' }}></div>
                        <div>
                          <p className='mb-0 fs-13 fw-600'>
                            {formik?.values?.
                              lst_LeadSourceCode
                              ?.value || '....'}
                          </p>
                          <p className='fs-11'>
                            Lead Source
                          </p>
                        </div>
                      </div>
                    </div>
                    <ProgressStepperLeadInquiry
                      // currentStep={currentStep}
                      // setCurrentStep={setCurrentStep}
                      // setCompletedStep={setCompletedStep}
                      // completedStep={completedStep}
                      formik={formik}
                      getdefaultLookups={getdefaultLookups}
                      isReadOnly={isReadOnly}
                      leadsInquirybyId={leadsInquirybyId}
                      leadsInquiryLookups={leadsInquiryLookups}
                      InactiveState={InactiveState}
                      IsSubmitted={IsSubmitted}

                    />
                    <Nav className='mb-leadTabs'>
                      <Nav.Item>
                        <Nav.Link className='nav-tabs ' eventKey="productServices">Products & Services</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link className='nav-tabs' eventKey="general">General</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link className='nav-tabs' eventKey="debriefing">Debriefing</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link className='nav-tabs' eventKey="marketing">Marketing</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link className='nav-tabs' eventKey="appointments">Appointments</Nav.Link>
                      </Nav.Item>
                      {/* <Nav.Item>
                        <Nav.Link className='nav-tabs' eventKey="related">Related</Nav.Link>
                      </Nav.Item> */}

                      {/* <Nav.Item>
                                                <Nav.Link className='nav-tabs' eventKey="notes">Notes</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link className="nav-tabs" eventKey="details" > Lead Details</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link className="nav-tabs" eventKey="contacts">Contacts</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link className="nav-tabs" eventKey="tasks">Tasks</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link className="nav-tabs" eventKey="opportunitydetails">Opportunity Details</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link className="nav-tabs" eventKey="assignments">Assignments</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link className="nav-tabs" eventKey="documents">Documents</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link className="nav-tabs" eventKey="propertyresources">Property Resources</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link className="nav-tabs" eventKey="projectprogress">Project Progress</Nav.Link>
                                            </Nav.Item> */}
                      {/* <Nav.Item>
                                                <Nav.Link className="nav-tabs" eventKey="meetings">Meetings</Nav.Link>
                                            </Nav.Item> */}
                      {/* <Nav.Item>
                                                <Nav.Link className="nav-tabs" eventKey="printouts">Printouts</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link className="nav-tabs" eventKey="metrics">Metrics</Nav.Link>
                                            </Nav.Item> */}
                    </Nav>
                  </div>
                </div>
              </Col>
              <Col sm={12}>
                <form onSubmit={formik.handleSubmit}>
                  <Tab.Content>
                    <Tab.Pane eventKey="productServices">
                      <ProductServicesTab
                        isReadOnly={isReadOnly}
                        formik={formik}
                        leadsInquiryLookups={leadsInquiryLookups}
                        getdefaultLookups={getdefaultLookups}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="general">
                      <div className='row' style={{ height: '566px', overflow: 'auto' }}>
                        <div className='col-md-4'>
                          <GeneralTabCol1 isReadOnly={isReadOnly} formik={formik}
                            leadsInquiryLookups={leadsInquiryLookups} getdefaultLookups={getdefaultLookups}
                            initialValues={initialValues}
                            formFieldRefs={formFieldRefs}
                          />

                        </div>
                        <div className='col-md-4'>
                          <GeneralTabCol2 isReadOnly={isReadOnly} formik={formik}
                            leadsInquiryLookups={leadsInquiryLookups} getdefaultLookups={getdefaultLookups}
                            formFieldRefs={formFieldRefs}
                          />
                        </div>
                        <div className='col-md-4'>
                          <GeneralTabCol3 isReadOnly={isReadOnly} formik={formik}
                            leadsInquiryLookups={leadsInquiryLookups} getdefaultLookups={getdefaultLookups}
                            formFieldRefs={formFieldRefs}
                          />
                        </div>
                      </div>

                    </Tab.Pane>
                    <Tab.Pane eventKey="debriefing"><Debriefing
                    /></Tab.Pane>
                    <Tab.Pane eventKey="marketing"><MarketingTab
                      isReadOnly={isReadOnly}
                      formik={formik}
                      leadsInquiryLookups={leadsInquiryLookups}
                      getdefaultLookups={getdefaultLookups}
                      getallActiveUsers={getallActiveUsers} /></Tab.Pane>
                    <Tab.Pane eventKey="appointments"><AppointmentTab getdefaultLookups={getdefaultLookups} leadsInquirybyId={leadsInquirybyId} getallActiveUsers={getallActiveUsers} /></Tab.Pane>
                    <Tab.Pane eventKey="clientNotes">First tab content</Tab.Pane>
                    {/* <Tab.Pane eventKey="related">Related</Tab.Pane> */}
                    <Tab.Pane eventKey="details" >
                      <LeadsUserDetail />
                    </Tab.Pane>
                    {/* <Tab.Pane eventKey="contacts" >
                      <LeadContacts />
                    </Tab.Pane>
                    <Tab.Pane eventKey="tasks">
                      <LeadUserTask />
                    </Tab.Pane>
                    <Tab.Pane eventKey="notes">
                      <LeadNotes />
                    </Tab.Pane>
                    <Tab.Pane eventKey="assignments">
                      <Assignments />
                    </Tab.Pane>
                    <Tab.Pane eventKey="clientvisits">
                      <ClientVisit />
                    </Tab.Pane>
                    <Tab.Pane eventKey="documents">
                      <Documents />
                    </Tab.Pane>
                    <Tab.Pane eventKey="meetings">
                      <Meetings />
                    </Tab.Pane>
                    <Tab.Pane eventKey="propertyresources">
                      <PropertyAddressTab />
                    </Tab.Pane>
                    <Tab.Pane eventKey="printouts">
                      <PrintOutsTab />
                    </Tab.Pane> */}
                    {/* <Tab.Pane eventKey="opportunitydetails">
                      <OpportunityDetails />
                    </Tab.Pane> */}
                  </Tab.Content>
                </form>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </div>
    </>
  )
}

export default UpdateLeadInquiry